module.exports = __webpack_public_path__ + "img/search.0ee1a2a2.svg";